import { FormHelper } from 'projects/admin/src/app/shared/form-helper';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { UntypedFormBuilder, UntypedFormControl, Validators, UntypedFormGroup } from '@angular/forms';
import { LocationModel } from 'projects/core/src/lib/models/location.model';
import { BaseForm } from 'projects/admin/src/app/classes/base-form';
import { Component, OnChanges, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';

@Component({
  selector: 'app-location-basedata',
  templateUrl: './location-basedata.component.html',
  styleUrls: ['./location-basedata.component.scss']
})
export class LocationBasedataComponent extends BaseForm implements OnInit, OnChanges {

  @Input() location: LocationModel = null;
  @Output() setEdit = new EventEmitter<string>();

  public country: string | null = null;
  public timezone: string | null = null;

  public form = this.fb.group({
    name: new UntypedFormControl('', [Validators.required]),
    tz: this.fb.group({})
  });

  constructor(
    private fb: UntypedFormBuilder,
    private ui: UiService,
    private api: ApiService,
    private router: Router,
    private auth: AuthStateService,
    private confirmation: ConfirmationService,
    public transloco: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    this.ui.setFocus();
  }

  ngOnChanges(): void {
    this.items = [];
    if (this.location !== null) {
      if (this.auth.hasRight('admin.location.delete')) {
        this.items.push({
          label: this.transloco.translate('common.labels.delete'),
          icon: 'pi pi-trash',
          styleClass: 'danger-button',
          disabled: (!this.location.deletable),
          command: () => {
            this.onDelete();
          }
        });
      }
      this.country = this.location.country;
      this.timezone = this.location.timezone;
    }
  }

  onSubmit(): void {
    this.ui.hideMessage();
    if (this.form.valid === true) {
      this.submitting = true;
      const payload = {
        name: this.form.get('name').value,
        country: this.country,
        timezone: this.timezone
      };
      this.api.saveModel('locations', this.location.id, payload).subscribe({
        next: (result: any) => {
          this.location.deserialize(result.data);
          this.ui.toastSuccess(this.transloco.translate('common.messages.saved', { value: this.location.name }), this.transloco.translate('common.saved'));
          this.stopEdit();
        },
        error: (error: any) => {
          this.ui.showMessage('error', this.transloco.translate(error.message), this.transloco.translate('common.error'));
          FormHelper.setBackendErrors(this.form, error.fielderrors);
        }
      }).add(() => {
        this.submitting = false;
      });
    } else {
      this.ui.showMessage('error', this.transloco.translate('common.error_on_form_please_correct'), this.transloco.translate('common.error'));
      FormHelper.markFormAsDirty(this.form);
    }
  }

  onDelete(): void {
    if (this.auth.hasRight('admin.location.delete')) {
      this.confirmation.confirm({
        message: this.transloco.translate('common.messages.really_delete', { value: this.location.name }),
        header: this.transloco.translate('common.really_delete'),
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.api.deleteModel('locations', this.location.id).subscribe({
            next: () => {
              this.ui.toastSuccess(this.transloco.translate('common.messages.deleted', { value: this.location.name }), this.transloco.translate('common.deleted'));
              this.router.navigate(['/locations']);
            },
            error: (error: any) => {
              this.ui.toastError(this.transloco.translate(error.message));
            }
          });
        }
      });
    }
  }

  protected startEdit(): void {
    if (this.location !== null) {
      this.form.patchValue({
        name: this.location.name,
      });
    }
    this.setEdit.emit('basedata');
    super.startEdit();
    this.ui.setFormFocus();
  }

  protected stopEdit(): void {
    this.setEdit.emit(null);
    super.stopEdit();
    this.ui.setFocus();
  }

  private minMaxValidator(group: UntypedFormGroup): any {
    return (group.get('max_value')?.value > group.get('min_value')?.value) ? null : { minMax: true };
  }

}
